import React, { useEffect, useState, useCallback } from 'react';
import { Mail, Phone, Calendar, Trash2 } from 'lucide-react';
import { useAuth } from '../../Context/AuthContext';
import Swal from 'sweetalert2';
import { API_URL } from '../../config';

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  const fetchMessages = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/admin/messages`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setMessages(data);
      }
    } catch (err) {
      console.error('Mesajlar yüklenemedi:', err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Emin misiniz?',
      text: "Bu mesajı kalıcı olarak silmek istiyor musunuz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#334155',
      confirmButtonText: 'Evet, Sil!',
      background: '#0f172a',
      color: '#fff'
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${API_URL}/admin/messages/${id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          Swal.fire({ icon: 'success', title: 'Silindi!', background: '#0f172a', color: '#fff', timer: 1500 });
          fetchMessages();
        }
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Hata!', background: '#0f172a', color: '#fff' });
      }
    }
  };

  if (loading) return <div className="admin-card">Yükleniyor...</div>;

  return (
    <div className="admin-messages">
      <div style={{ marginBottom: '2rem' }}>
        <h1 className="admin-card-title" style={{ fontSize: 'clamp(1.5rem, 4vw, 2.2rem)', marginBottom: '0.25rem' }}>Mesaj Yönetimi</h1>
        <p style={{ color: 'var(--text-dim)', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}>Gelen iletişim formu mesajlarını buradan takip edebilirsiniz.</p>
      </div>

      <div className="admin-card" style={{ borderRadius: '1.25rem', border: '1px solid var(--navbar-border)', padding: 0 }}>
        <div className="admin-table-wrapper">
          <table className="admin-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
            <thead style={{ background: 'rgba(255,255,255,0.02)' }}>
              <tr>
                <th style={{ padding: '1rem 1.5rem', whiteSpace: 'nowrap' }}>Gönderen</th>
                <th style={{ padding: '1rem 1.5rem', whiteSpace: 'nowrap' }}>İletişim</th>
                <th style={{ padding: '1rem 1.5rem', whiteSpace: 'nowrap' }}>Mesaj</th>
                <th style={{ padding: '1rem 1.5rem', whiteSpace: 'nowrap' }}>Tarih</th>
                <th style={{ padding: '1rem 1.5rem', textAlign: 'right', whiteSpace: 'nowrap' }}>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {messages.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-dim)' }}>Gelen mesaj bulunmuyor.</td>
                </tr>
              ) : (
                messages.map((item) => (
                  <tr key={item.id} style={{ borderBottom: '1px solid var(--navbar-border)' }}>
                    <td style={{ padding: '1rem 1.5rem', fontWeight: '700', whiteSpace: 'nowrap' }}>{item.name} {item.surname}</td>
                    <td style={{ padding: '1rem 1.5rem' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', fontSize: '0.85rem' }}>
                        {item.phone && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', whiteSpace: 'nowrap' }}>
                            <Phone size={14} color="#00d1ff" /> {item.phone}
                          </div>
                        )}
                        {item.email && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', opacity: item.phone ? 0.6 : 1, whiteSpace: 'nowrap' }}>
                            <Mail size={14} color="#00d1ff" /> {item.email}
                          </div>
                        )}
                        {!item.phone && !item.email && <span style={{ color: 'var(--text-dim)' }}>-</span>}
                      </div>
                    </td>
                    <td style={{ padding: '1rem 1.5rem' }}>
                      <div style={{ minWidth: '250px', maxWidth: '400px', fontSize: '0.85rem', color: 'var(--text-dim)' }}>
                        {item.message}
                      </div>
                    </td>
                    <td style={{ padding: '1rem 1.5rem' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
                        <Calendar size={14} color="var(--text-dim)" /> 
                        {new Date(item.created_at).toLocaleDateString()}
                      </div>
                    </td>
                    <td style={{ padding: '1rem 1.5rem', textAlign: 'right' }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                        <button onClick={() => handleDelete(item.id)} style={{ background: 'rgba(239, 68, 68, 0.05)', border: 'none', color: '#f87171', padding: '0.4rem', borderRadius: '0.5rem', cursor: 'pointer' }} title="Sil">
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Messages;

